import React from 'react';
import {useI18n} from '@shopify/react-i18n';
import {PageHeader} from 'sections/services-marketplace/experts/components';
import {Routes} from 'sections/services-marketplace/experts/utilities';

export default function PageBanner() {
  const [i18n] = useI18n();

  return (
    <PageHeader
      title={i18n.translate('SavedExperts.PageHeader.title')}
      description={i18n.translate('SavedExperts.PageHeader.description')}
      image={Routes.imagePath('svg/saved-experts.svg')}
    />
  );
}
